// extracted by mini-css-extract-plugin
export var actionButton = "_e0-t";
export var buttonContainer = "_e0-0";
export var buttonContainer2 = "_e0-1";
export var buttonSection = "_e0-2";
export var details = "_e0-3";
export var dropdownItem = "_e0-5";
export var dropdownItemsContainer = "_e0-4";
export var fileInput = "_e0-r";
export var headerButton = "_e0-6";
export var icon = "_e0-7";
export var input = "_e0-8";
export var macroListItem = "_e0-9";
export var mainContent = "_e0-a";
export var microText = "_e0-b";
export var modal = "_e0-w";
export var optionsButton = "_e0-c";
export var paperclip = "_e0-s";
export var pillContent = "_e0-d";
export var preview = "_e0-e";
export var preview2 = "_e0-f";
export var quillEditor = "_e0-q";
export var selectedMacro = "_e0-g";
export var sidebar = "_e0-h";
export var sidebarHeader = "_e0-j";
export var sidebarList = "_e0-i";
export var sidebarListItem = "_e0-k";
export var sidebarSearch = "_e0-l";
export var snoozeDurationWrapper = "_e0-v";
export var statusPillContainer = "_e0-m";
export var tagsContainer = "_e0-n";
export var unselectedMacro = "_e0-o";
export var variable = "_e0-u";
export var wrapper = "_e0-p";